import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

interface ConfirmCompleteSaveModalProps {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmSaveSurveyModal({
  open,
  loading = true,
  onCancel,
  onConfirm,
}: ConfirmCompleteSaveModalProps) {
  return (
    <Dialog open={open}>
      <DialogTitle>Save Survey</DialogTitle>

      <DialogContent>
        Are you sure you would like to save this survey?
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={loading}
          startIcon={
            loading ? <CircularProgress size="12px" color="inherit" /> : null
          }
        >
          {loading ? 'Saving...' : 'Save Survey'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
